export class TipoProducto {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
